// extracted by mini-css-extract-plugin
export var columnItem = "_bq-3";
export var columnItemDraggable = "_bq-4";
export var dragHandle = "_bq-0";
export var dragHandleHovered = "_bq-1";
export var dropdown = "_bq-5";
export var dropdownContent = "_bq-7";
export var dropdownInner = "_bq-6";
export var filterDropdownHeader = "_bq-8";
export var icon = "_bq-2";
export var sectionDivider = "_bq-9";